export { pageview } from './gtag'
export { handleLoadEvent } from './handleLoadEvent'
